"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const auth0_react_1 = require("@auth0/auth0-react");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_router_config_1 = require("react-router-config");
const AuthorizationScopes_1 = __importDefault(require("../../../common/js/enums/AuthorizationScopes"));
const translation_1 = require("../../../common/js/helper/translation");
const withAuthorization_1 = __importDefault(require("../../../common/js/hoc/withAuthorization"));
const Paths = __importStar(require("../../constants/Paths"));
const DataLayerLabels_1 = __importDefault(require("../../enums/DataLayerLabels"));
const dataLayer_1 = require("../../helper/dataLayer");
const history_1 = require("../../helper/history");
const Countries_1 = __importDefault(require("../../stores/Countries"));
const RegistrationStore_1 = __importDefault(require("../../stores/RegistrationStore"));
const SuluResellers_1 = __importDefault(require("../../stores/SuluResellers"));
class RegistrationPage extends react_1.default.Component {
    componentDidMount() {
        const { route } = this.props;
        document.title = (0, translation_1.t)('registration_page_title');
        (0, dataLayer_1.pushToDataLayerNavigation)({
            [DataLayerLabels_1.default.dlvNavigationLevelOne]: (0, translation_1.t)('registration.sign_up.title'),
        });
        RegistrationStore_1.default.loadSessionStorage();
        Countries_1.default.loadAllCountries();
        if (!!RegistrationStore_1.default.generalData.selectedCountryCode) {
            SuluResellers_1.default.loadResellers(RegistrationStore_1.default.generalData.selectedCountryCode);
        }
        if (!!RegistrationStore_1.default.generalData.currentStep &&
            !!route?.routes &&
            route.routes.filter((config) => config.path === RegistrationStore_1.default.generalData.currentStep).length > 0) {
            (0, history_1.pushHistory)(this.props.history, RegistrationStore_1.default.generalData.currentStep);
            return;
        }
        (0, history_1.pushHistory)(this.props.history, Paths.PATH_REGISTRATION_VERIFICATION_CODE);
    }
    render() {
        return react_1.default.createElement(react_1.default.Fragment, null, (0, react_router_config_1.renderRoutes)(this.props.route?.routes));
    }
}
exports.default = (0, auth0_react_1.withAuth0)((0, withAuthorization_1.default)({ scope: AuthorizationScopes_1.default.REGISTRATION_CREATE })((0, mobx_react_1.observer)(RegistrationPage)));
